import { ChapterLabel } from "./ChapterLabel";
import { Reveal } from "./Reveal";

export const WhyMonthly = () => (
  <section id="why-monthly" className="py-24 sm:py-32" data-testid="why-monthly-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterLabel text="Chapter 07 // Continuity" />
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-tight text-white">
            Why Monthly, Not One-Time?
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6 lg:col-start-7">
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed border-l-2 border-white/20 pl-6 sm:pl-8">
            Your Google ranking shifts. Competitors move. Leads slow down without
            warning. A one-time check only shows you today — a monthly report
            shows you what's changing before it costs you customers.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
